{
  "RESET_PASSWORD": {
    "TITLE": "Скинути пароль",
    "DESCRIPTION": "Введіть адресу електронної пошти, яку ви використовуєте для входу в контакт-центр, щоб отримати інструкцію зі скидання пароля.",
    "GO_BACK_TO_LOGIN": "Якщо ви хочете повернутися на сторінку авторизації,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Введіть адресу електронної пошти.",
      "ERROR": "Введіть дійсну адресу електронної пошти."
    },
    "API": {
      "SUCCESS_MESSAGE": "Посилання для зміни пароля було надіслано на вашу електронну пошту.",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
    },
    "SUBMIT": "Додати"
  }
}
